import { SearchableDropdown } from './SearchableDropdown';

interface GreaterAreaDropdownProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function GreaterAreaDropdown({
  value,
  onChange,
  placeholder = 'Select Greater Area',
  className,
}: GreaterAreaDropdownProps) {
  return (
    <SearchableDropdown
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search greater areas..."
      className={className}
      endpoint="greater-areas"
      emptyText="No greater areas found."
    />
  );
}
